import { defineStore } from 'pinia'
import { ref } from 'vue'
import debounce from 'lodash/debounce'
import { useGlobalStore } from "@/store/storeGlobal"

export const useRefreshStore = defineStore('refreshStore', () => {
  const globalStore = useGlobalStore()
  const refreshTrigger = ref(0)
  const debugPrefix = '[Refresh]'

  const triggerRefresh = debounce(() => {
    globalStore.debug(`${debugPrefix} Triggering refresh (count: ${refreshTrigger.value + 1})`)
    refreshTrigger.value++
  }, 250) // 250ms debounce

  // For debugging, kan være nyttig å se når store'en initialiseres
  globalStore.debug(`${debugPrefix} Store initialized`)

  return {
    refreshTrigger,
    triggerRefresh
  }
})
